import { Ball } from "./physics/Ball";
import { GameVars } from "./GameVars";
import { GameConstants } from "./GameConstants";
import { AudioManager } from "./AudioManager";

    export class BallsManager  extends Phaser.Group {

        public static KICKOFF_PX = 384;
        public static KICKOFF_PY = 55;
        public static RETURN_TO_KICKOFF_PY = - 50;

        public shooterMoving: boolean;

        private ball: Ball;
        private ballAttachedToForward: Phaser.Sprite;
        private ballAttachedToForwardFrameName: string;
        private shooterImageAiming: Phaser.Image;
        private shooterShootingImage: Phaser.Image;
        private shooterIdleImage: Phaser.Image;
        private shooterTween: Phaser.Tween;
        private shooterDeltaY: number;
        private shooterlimitY: number;

        constructor(game: Phaser.Game) {

            super(game, null, "balls-manager", false);

            // la imagen del delantero apuntando
            let aiming_frame_ID: number      = (GameVars.playerID - 1) * 5 + 1;
            let textureAimingName: string      = "delantero_" +  GameVars.formatNumberForTextureAtlas(aiming_frame_ID);

            this.shooterImageAiming = new Phaser.Image( this.game,
                                                BallsManager.KICKOFF_PX,
                                                BallsManager.KICKOFF_PY - 150,
                                                "" + GameVars.playerID,
                                                textureAimingName);

            this.shooterImageAiming.anchor.setTo(.5);
            this.shooterImageAiming.visible = false;
            this.add(this.shooterImageAiming);

            // la imagen del delantero cuando chuta
            let shooting_frame_ID  = (GameVars.playerID - 1) * 5 + 5;
            let textureShootingName      = "delantero_" +  GameVars.formatNumberForTextureAtlas(shooting_frame_ID);
            this.shooterShootingImage = new Phaser.Image( this.game,
                                                BallsManager.KICKOFF_PX,
                                                BallsManager.KICKOFF_PY,
                                                "" + GameVars.playerID,
                                                textureShootingName);
            this.shooterShootingImage.anchor.setTo(.5);
            this.shooterShootingImage.visible = false;
            this.add(this.shooterShootingImage);

            let idle_frame_ID        = ( GameVars.playerID - 1) * 5 + 2;
            let textureIdleName      = "delantero_" +  GameVars.formatNumberForTextureAtlas(idle_frame_ID);
            this.shooterIdleImage = new Phaser.Image( this.game,
                                                BallsManager.KICKOFF_PX,
                                                BallsManager.KICKOFF_PY,
                                                    "" + GameVars.playerID,
                                                textureIdleName);
            this.shooterIdleImage.anchor.set(.5);
            this.shooterIdleImage.visible = false;
            this.add(this.shooterIdleImage);

            // la imagen de la pelota
            this.ballAttachedToForward = new Phaser.Sprite(this.game, 0, 60, "texture_atlas_2");

            let tournamentData = GameVars.tournamentData;

            if (tournamentData.name === GameConstants.OCEANIA_CUP) {
                this.ballAttachedToForwardFrameName = "balon_oceania_cup";
            } else if (tournamentData.name === GameConstants.AFRICA_CUP) {
                this.ballAttachedToForwardFrameName = "balon_africa_cup";
            } else if (tournamentData.name === GameConstants.ASIAN_CUP) {
                this.ballAttachedToForwardFrameName = "balon_asia_cup";
            } else if (tournamentData.name === GameConstants.GOLD_CUP) {
                this.ballAttachedToForwardFrameName = "balon_gold_cup";
            } else if (tournamentData.name === GameConstants.AMERICA_CUP) {
                this.ballAttachedToForwardFrameName = "balon_america_cup";
            } else if (tournamentData.name === GameConstants.OLYMPIC_GAMES) {
                this.ballAttachedToForwardFrameName = "balon_olympics";
            } else if (tournamentData.name === GameConstants.EUROCUP) {
                this.ballAttachedToForwardFrameName = "balon_eurocup";
            } else if (tournamentData.name === GameConstants.CONFEDERATIONS_CUP) {
                this.ballAttachedToForwardFrameName = "balon_confederations";
            } else if (tournamentData.name === GameConstants.WORLD_CUP) {
                this.ballAttachedToForwardFrameName = "balon_world_cup";
            }

            this.ballAttachedToForward.frameName = this.ballAttachedToForwardFrameName;

            this.ballAttachedToForward.anchor.set(.5);
            this.shooterImageAiming.addChild( this.ballAttachedToForward);
            this.shooterImageAiming.angle = -80;

            this.shooterTween = this.game.add.tween(this.shooterImageAiming);
            this.shooterTween.to({angle: 80}, 1000, Phaser.Easing.Quadratic.InOut, true, 0, -1, true);
            this.shooterTween.pause();

            this.shooterMoving = false;
            GameVars.isShooterReady = false;

            // por que el tween se paraba al perder el foco
            this.game.onPause.add(this.onGamePaused, this);
            this.game.onResume.add(this.onGameResumed, this);
        }

        // cuando pierde el foco se para el tween
        // quitar los listeners al destruirlo
        public destroy(destroyChildren?: boolean, soft?: boolean): void {

            this.game.onPause.remove(this.onGamePaused, this);
            this.game.onResume.remove(this.onGameResumed, this);

            super.destroy(destroyChildren, soft);
        }

        public update(): void {

            super.update();

            if ( this.shooterMoving ) {

                this.shooterIdleImage.y     += this.shooterDeltaY;
                this.shooterImageAiming.y   += this.shooterDeltaY;

                if (this.shooterDeltaY < 0) {

                    if (this.shooterIdleImage.y < this.shooterlimitY) {

                        this.shooterIdleImage.visible = false;
                        this.shooterMoving = false;
                    }

                } else {

                    if (this.shooterImageAiming.y > this.shooterlimitY) {

                        GameVars.isShooterReady = true;
                        this.shooterTween.resume();
                        this.shooterMoving = false;
                    }
                }
            }
        }

        public start(): void {

            if ( this.shooterMoving ) {
                return;
            }

            this.shooterMoving = true;

            this.shooterDeltaY = 8;
            this.shooterlimitY = BallsManager.KICKOFF_PY;

            this.shooterImageAiming.y = -150;
            this.shooterIdleImage.y = -150;

            this.shooterImageAiming.visible = true;
            this.ballAttachedToForward.visible = true;
            this.shooterIdleImage.visible = false;

            if ( this.ballAttachedToForward.frameName === "balon_fuego" ) {
                this.ballAttachedToForward.frameName = this.ballAttachedToForwardFrameName;
            }

            this.ball = new Ball(this.game, BallsManager.KICKOFF_PX,  BallsManager.KICKOFF_PY);
            this.ball.visible = false;
            this.addAt(this.ball, 0);
        }

        public kickOff(): void {

            GameVars.isShooterReady = false;

            this.shooterImageAiming.visible = false;
            this.ballAttachedToForward.visible = false;
            this.shooterShootingImage.angle = this.shooterImageAiming.angle;
            this.shooterShootingImage.visible = true;

            this.ball.visible = true;
            this.ball.initPhysics();

            let angleInRadians: number = Math.PI / 180 * (this.shooterImageAiming.angle + 90);

            let force: number = 900;

            this.ball.body.velocity.x = force * Math.cos(angleInRadians);
            this.ball.body.velocity.y = force * Math.sin(angleInRadians);

            this.ball.body.angularVelocity = Math.random() > .5 ? -10 : 10;

            // tras un delay ocultar la imagen del jugador apuntando
            this.game.time.events.add(200, this.hideShooter, this);

            AudioManager.getInstance().playEffect( "chuta_chutador" );
        }

        public onExtraBall(x: number, y: number, isBallOfFire: boolean): void {

            var ball: Ball = new Ball(this.game, x, y, true);
            ball.initPhysics();
            if (isBallOfFire) {
                ball.setOnFire();
            }
            this.add(ball);
        }

        public onBallOnFireSelected(): void {

            // la pelota q esta por detras
            this.ball.setOnFire();

            // cambiar la imagen de la pelota enganchada al delantero
            this.ballAttachedToForward.frameName = "balon_fuego";
        }

        public onGamePaused(): void {

            if (this.shooterImageAiming.visible) {
                this.shooterTween.pause();
            }
        }

        public onGameResumed(): void {

            if (this.shooterImageAiming.visible) {
                this.shooterTween.resume();
            }
        }

        public shootBall( px: number, py: number, angle: number, powerKick: boolean, ballOnFire: boolean, isExtraBall: boolean): void {

            this.ball = new Ball(this.game, px, py, isExtraBall);
            this.ball.initPhysics();

            if (ballOnFire) {
                this.ball.setOnFire();
            }

            this.add(this.ball);

            var angleInRadians: number = Math.PI / 180 * angle;

            var force: number = powerKick ? 1600 : 700;

            this.ball.body.velocity.x = force * Math.cos(angleInRadians);
            this.ball.body.velocity.y = force * Math.sin(angleInRadians);
        }

         private hideShooter(): void {

            this.shooterTween.pause();

            this.shooterShootingImage.visible = false;
            this.shooterImageAiming.visible = false;
            this.shooterIdleImage.visible = true;
            this.shooterIdleImage.y = BallsManager.KICKOFF_PY;

            this.shooterDeltaY = -7;
            this.shooterlimitY = -150;

            this.shooterMoving = true;
        }
    }
